module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-cleaning-fr-FR@2x-729ac2661476d75140c07f9838a542f3.png";